export const getSeverity = (str: string) => {
  switch (str) {
    case 'warning':
      return 'warn';
    default:
      return str;
  }
};
